const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

export function getSupabaseConfig() {
  if (!supabaseUrl || !supabasePublishableKey) {
    throw new Error('Missing required Supabase environment configuration.');
  }

  return {
    url: supabaseUrl,
    publishableKey: supabasePublishableKey,
  };
}

export function getSupabaseFunctionsUrl(functionPath?: string) {
  const { url } = getSupabaseConfig();

  if (!functionPath) {
    return `${url}/functions/v1`;
  }

  return `${url}/functions/v1/${functionPath.replace(/^\/+/, '')}`;
}